import { db, storage } from "./index"

export const uploadImage = async (base64, uniqueFilename, path) => {
  const storageRef = storage.ref(`Admin/${path}`).child(uniqueFilename)
  const task = storageRef.putString(base64.split("data:image/png;base64,")[1], "base64", {
    contentType: "image/png",
  })
  return new Promise((resolve, reject) => {
    task
      .then(() => {
        resolve(storageRef.getDownloadURL())
      })
      .catch((error) => {
        console.log("Erro ao buscar url", error)
        reject(error)
      })
  })
}

const uploadFile = async (base64, uniqueFilename, typeFile) => {
  const base64Mime = (encoded, isExtension = false) => {
    let result = null

    if (typeof encoded !== "string") {
      return result
    }

    let mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)

    if (mime && mime.length) {
      result = mime[1]
    }

    return result
  }

  const storageRef = storage
    .ref(`Admin/${typeFile}/`)
    .child(`${uniqueFilename}${typeFile && "." + typeFile}`)

  const task = storageRef.putString(base64.split(",")[1], "base64", {
    contentType: base64Mime(base64),
  })
  return new Promise((resolve, reject) => {
    task
      .then(() => {
        resolve(storageRef.getDownloadURL())
      })
      .catch((error) => {
        console.log("Erro ao buscar url", error)
        reject(error)
      })
  })
}

export const sendFile = async (base64, contentId, typeFile) => {
  if (!base64 || !contentId) return ""
  return await uploadFile(base64, `Admin-file-${contentId}`, typeFile)
}

export const addItem = async (tableName, item) => {
  const table = db.collection(tableName).doc(item.id)
  const id = table.id
  const data = { active: true, ...item, id }
  table.set(data).catch(() => {})
  return Promise.resolve(data)
}

export const updateItem = async (tableName, item) => {
  const table = db.doc(`${tableName}/${item.id}`)
  const data = { ...item }
  console.log({ table, data })
  table.update(data)
  return Promise.resolve(data)
}
